import Tab from "components/Tab";
import Frameworks from "../../../../contents/docs/integrate/_snippets/frameworks.mdx";
import APIInstall from "../../../../contents/docs/integrate/_snippets/install-api.mdx";
import WebInstall from "../../../../contents/docs/integrate/_snippets/install-web.mdx";
import ReactInstall from "../../../../contents/docs/integrate/_snippets/install-react.mdx";
import NodeInstall from "../../../../contents/docs/integrate/_snippets/install-node.mdx";
import PythonInstall from "../../../../contents/docs/integrate/_snippets/install-python.mdx";
import PHPInstall from "../../../../contents/docs/integrate/_snippets/install-php.mdx";
import RubyInstall from "../../../../contents/docs/integrate/_snippets/install-ruby.mdx";
import GoInstall from "../../../../contents/docs/integrate/_snippets/install-go.mdx";
import ReactNativeInstall from "../../../../contents/docs/integrate/_snippets/install-react-native.mdx";
import AndroidInstall from "../../../../contents/docs/integrate/_snippets/install-android.mdx";
import IOSInstall from "../../../../contents/docs/integrate/_snippets/install-ios.mdx";
import JavaInstall from "../../../../contents/docs/integrate/_snippets/install-java.mdx";
import RustInstall from "../../../../contents/docs/integrate/_snippets/install-rust.mdx";
import FlutterInstall from "../../../../contents/docs/integrate/_snippets/install-flutter.mdx";
import ElixirInstall from "../../../../contents/docs/integrate/_snippets/install-elixir.mdx";
import DotNetInstall from "../../../../contents/docs/integrate/_snippets/install-dotnet.mdx";
import Wizard from "../../../../contents/docs/getting-started/_snippets/wizard.mdx";
import * as React from 'react';
export default {
  Tab,
  Frameworks,
  APIInstall,
  WebInstall,
  ReactInstall,
  NodeInstall,
  PythonInstall,
  PHPInstall,
  RubyInstall,
  GoInstall,
  ReactNativeInstall,
  AndroidInstall,
  IOSInstall,
  JavaInstall,
  RustInstall,
  FlutterInstall,
  ElixirInstall,
  DotNetInstall,
  Wizard,
  React
};